import React, { useEffect, useState } from 'react';
import AxiosServices from 'src/Services/axiosServices';

interface IUser {
    id: number;
    name: string;
    username: string;
    email: string;
    address: {
        street: string;
        suite: string;
        city: string;
        zipcode: string;
        geo: {
            lat: string;
            lng: string;
        }
    },
    phone: string;
    website: string;
    company: {
        name: string;
        catchPhrase: string;
        bs: string;
    }
}

const Gambler: React.FC = () => {

    const [ post, setPost ] = useState([]);

    useEffect(() => {
        // axios.get("https://jsonplaceholder.typicode.com/users").then((data) => {
        //     console.log(data);
        //     setPost(data?.data);
        // });
        AxiosServices.getUsers(setPost);
    }, []);

    return (
        <div>
            <h1>
                Parieurs
            </h1>
            {post.map((item: IUser, i) => {
                return (
                    <li key={i}>
                        <p>{item?.name}</p>
                        <p>{item?.username}</p>
                        <p>{item?.email}</p>
                    </li>
                );
            })}
        </div>
    );

}

export default Gambler;
